// Acciones
import {CHANGE_COMPANY} from "../actionTypes";

// Acción de cambiar empresa
export const changeCompany = (company) => ({
    type: CHANGE_COMPANY,
    payload: company
});
